"use strict";
import React from "react";
import Account from "../../api/account";
import Address from "./address";
import CarrierName from "../carrier_name";
import CarrierTypeAhead from "../carrier_typeahead";
import generalFormatter from "../../formatters/general";
import LineItems from "../carrier_invoice/line_items";
import PaymentStrategyEditor from "./payment_strategy_editor";
import PossibleAdjustments from "./possible_adjustments";
function onPaymentAmountDragOver(e) {
  e.preventDefault();
}
function onPaymentAmountDrop(e) {
  if (e.stopPropagation) {
    e.stopPropagation();
  }
  e.preventDefault();
  e.target.value = e.dataTransfer.getData("text/plain");
  e.target.dispatchEvent(new Event("input", { bubbles: true }));
}
const PaymentInformation = React.createClass({
  getInitialState: function() {
    return {};
  },
  input: function(field, type) {
    if (field == "payOn") {
      return /* @__PURE__ */ React.createElement(
        "input",
        {
          type,
          value: this.props.payment[field],
          onChange: this.updateField(field),
          disabled: this.props.readOnly
        }
      );
    } else {
      return /* @__PURE__ */ React.createElement(
        "input",
        {
          type,
          disabled: this.props.readOnly,
          valueLink: this.myLinkState(field),
          onBlur: this.props.invoiceChangeComplete,
          onKeyPress: this.props.keyPressNotifier(field),
          onDragOver: onPaymentAmountDragOver,
          onDrop: onPaymentAmountDrop,
          placeholder: "Payment Amount"
        }
      );
    }
  },
  myLinkState: function(field) {
    var component = this;
    var value = this.state[field] || this.props.payment["amount"];
    return {
      value,
      requestChange: function(value2) {
        var state = {};
        state[field] = value2;
        component.setState(state);
        var vl = value2 ? generalFormatter.cleanAmount(value2).toString() : "";
        component.props.updatePaymentField(field, vl);
        component.props.invoiceFieldChanged(field, vl);
      }
    };
  },
  render: function() {
    return /* @__PURE__ */ React.createElement("div", { "data-component": "PaymentInformation" }, /* @__PURE__ */ React.createElement("div", { className: "row load-detail__invoice-area" }, /* @__PURE__ */ React.createElement("div", { className: "small-5 column" }, /* @__PURE__ */ React.createElement("label", null, "Payment Amount"), /* @__PURE__ */ React.createElement("div", { className: "row collapse" }, /* @__PURE__ */ React.createElement("div", { className: "small-1 columns" }, /* @__PURE__ */ React.createElement("span", { className: "prefix" }, "$")), /* @__PURE__ */ React.createElement("div", { className: "small-9 columns" }, this.input("amount_to_pay", "text"), this.possiblePossibleAdjustments()))), /* @__PURE__ */ React.createElement("div", { className: "small-5 column" }, this.paymentDueOnInput()), this.lineItems(), /* @__PURE__ */ React.createElement("div", { className: "load-detail__invoice-carrier-container" }, /* @__PURE__ */ React.createElement("div", { className: "small-5 column" }, /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "load-detail__name-wrapper",
        style: { display: "flex", justifyContent: "space-between" }
      },
      /* @__PURE__ */ React.createElement("div", { className: "load-detail__name-container" }, /* @__PURE__ */ React.createElement(
        "label",
        {
          className: "load-detail__invoice-label",
          "data-tooltip": true,
          "aria-haspopup": "true",
          title: "The " + Account.carrierTerm() + " who the payment will be sent to"
        },
        "Invoice ",
        Account.carrierTerm()
      ), /* @__PURE__ */ React.createElement("label", { className: "load-detail__invoice-name-label show_for_reskin" }, Account.carrierTerm(), " name"), this.invoiceCarrierOrEditor()),
      this.props.children
    )), /* @__PURE__ */ React.createElement("div", { className: "small-5 column load-detail__invoice_address_container" }, /* @__PURE__ */ React.createElement("label", null, this.payToLabel(), this.possibleEditAddressLink()), /* @__PURE__ */ React.createElement("div", { className: "load-detail__invoice_address" }, this.addressOrEditor(), this.remitToValidationMessage(), this.remitToUpdateReminder())))));
  },
  paymentDueOnInput: function() {
    if (Account.carrierInvoiceCanModifyPaymentDueOn()) {
      return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("label", null, "Payment Due On"), this.input("payOn", "date"));
    } else {
      return /* @__PURE__ */ React.createElement("div", null);
    }
  },
  shouldShowLineItems: function() {
    return Account.shouldShowLineItems() || this.props.creatingLoad;
  },
  lineItems: function() {
    if (this.shouldShowLineItems()) {
      return /* @__PURE__ */ React.createElement("div", { className: "small-10 column" }, /* @__PURE__ */ React.createElement(
        LineItems,
        {
          carrierInvoice: this.props.carrierInvoice,
          payment: this.props.payment,
          load: this.props.load,
          creatingLoad: this.props.creatingLoad,
          invoiceChangeComplete: this.props.invoiceChangeComplete
        }
      ));
    }
  },
  remitToValidationMessage: function() {
    if (!Account.currentSettings().show_carrier_invoice_remit_to_validation) {
      return "";
    }
    switch (this.props.carrierInvoice.remit_to_validation_result) {
      case "no_tms_address":
        var message = "No pay-to address found in TMS.";
        var className = "warning";
        break;
      case "remit_to_zips_match":
        var message = "Pay-to zip codes match.";
        var className = "success";
        break;
      case "check_factor_remit_to":
        var message = "Pay-to may not match factored invoice.";
        var className = "error";
        break;
      case "check_remit_to":
        var message = "Pay-to may not match invoice.";
        var className = "error";
        break;
      case "cant_find_remit_to_zip":
        var message = "Can't find pay-to zip code.";
        var className = "error";
        break;
      case "triumphpay_remit_to":
        var message = "Pay via TriumphPay";
        var className = "success";
        break;
      case "triumphpay_inconclusive":
        var message = "Pay via TriumphPay";
        var className = "";
        break;
      default:
        return "";
    }
    className += " load-detail__remit_to_validation";
    return /* @__PURE__ */ React.createElement("div", { className }, message);
  },
  remitToUpdateReminder: function() {
    if (Account.currentSettings().use_triumph_pay_carrier_remit_to && this.props.carrierInvoice.remit_to_validation_result != "remit_to_zips_match") {
      return /* @__PURE__ */ React.createElement("div", { className: "load-detail__remit_to_update_reminder" }, "If needed, send NOA to TriumphPay or update remittance in your system. Updates may not appear immediately.");
    }
  },
  possiblePossibleAdjustments: function() {
    if (this.props.carrierInvoice.quickpay_disposition === "not_applied_to_invoice") {
      return /* @__PURE__ */ React.createElement(
        PossibleAdjustments,
        {
          expectedTotal: this.tmsTotal(),
          load: this.props.load,
          carrierInvoice: this.props.carrierInvoice
        }
      );
    }
  },
  tmsTotal: function() {
    if (this.props.load.load.carrier_charge) {
      return parseFloat(this.props.load.load.carrier_charge);
    }
    return 0;
  },
  payToLabel: function() {
    if (Account.currentSettings().use_triumph_pay_carrier_remit_to && this.carrier().payment_address_source === "triumphpay") {
      return "TriumphPay Payee";
    }
    if (this.state.editing) {
      return Account.carrierTerm() + " Payment Settings";
    }
    if (!this.allowEditingCarrierPaymentStrategy()) {
      return Account.carrierTerm() + " Remittance Address";
    }
    switch (this.carrier().payment_strategy) {
      case "direct":
        return "Pay Direct to " + Account.carrierTerm();
      case "factor":
        return "Pay Via Factor";
      default:
        return "Pay To";
    }
  },
  invoiceCarrierOrEditor: function() {
    if (this.state.editingCarrier) {
      return /* @__PURE__ */ React.createElement("div", { className: "load-detail__invoice-name-editor" }, /* @__PURE__ */ React.createElement(
        CarrierTypeAhead,
        {
          carrier: this.carrierForTypeahead(),
          onSelectCarrier: this.carrierWasSet,
          onClearCarrier: this.cancelEditingCarrier
        }
      ));
    }
    return /* @__PURE__ */ React.createElement("h6", null, /* @__PURE__ */ React.createElement(CarrierName, { carrierID: this.carrier().id }), "\xA0", this.possibleCarrierEditorLink());
  },
  possibleCarrierEditorLink: function() {
    if (!this.props.readOnly) {
      return /* @__PURE__ */ React.createElement("a", { onClick: this.startEditingCarrier }, /* @__PURE__ */ React.createElement("i", { className: "fi-pencil" }));
    }
  },
  carrierForTypeahead: function() {
    return this.state.carrier || this.props.carrier;
  },
  carrier: function() {
    return this.props.carrier;
  },
  carrierWasSet: function(carrier) {
    this.setState({ carrier });
    this.props.onCarrierChanged(carrier);
  },
  cancelEditingCarrier: function() {
    this.props.onCarrierChanged(null);
  },
  startEditingCarrier: function() {
    this.setState({ editingCarrier: true });
  },
  updateField: function(field) {
    return (event) => {
      this.props.updatePaymentField(field, event.target.value);
    };
  },
  addressOrEditor: function() {
    if (this.state.editing) {
      return /* @__PURE__ */ React.createElement(
        PaymentStrategyEditor,
        {
          carrier: this.carrier(),
          onSave: this.savePaymentStrategy
        }
      );
    }
    return /* @__PURE__ */ React.createElement(Address, { source: this.carrier().payment_address });
  },
  saveAddress: function(address) {
    return this.props.saveAddress(address).then(() => {
      this.setState({ editing: false });
    });
  },
  savePaymentStrategy: function(paymentStrategy, details) {
    return this.props.savePaymentStrategy(paymentStrategy, details).then(() => this.setState({ editing: false }));
  },
  possibleEditAddressLink: function() {
    if (this.props.canEditAddress && !this.props.readOnly && this.allowEditingCarrierPaymentStrategy()) {
      if (this.state.editing) {
        return /* @__PURE__ */ React.createElement("a", { className: "right payment-info__edit", onClick: this.cancelEditing }, "cancel");
      }
      return /* @__PURE__ */ React.createElement("a", { className: "right payment-info__edit", onClick: this.startEditing }, "edit");
    }
  },
  allowEditingCarrierPaymentStrategy: function() {
    return Account.currentSettings().allow_editing_carrier_payment_strategy && this.carrier().payment_strategy != "triumphpay";
  },
  startEditing: function() {
    this.setState({ editing: true });
  },
  cancelEditing: function() {
    this.setState({ editing: false });
  }
});
export default PaymentInformation;
